/* eslint-disable no-param-reassign */
// eslint-disable-next-line import/no-extraneous-dependencies
import debounce from 'lodash/debounce';

const initQuickSearch = () => {
  const TestWrapper = document.querySelector('.js-quicksearch');
  const searchInp = TestWrapper.querySelector('input[type="search"]');
  if (!TestWrapper || !searchInp) return;

  const searchAction = async (value, quickSearch, linksWrap) => {
    const wrapper = quickSearch.closest('.js-quicksearch');
    wrapper.classList.remove('is-notfound');
    if (!value.trim()) {
      if (linksWrap) linksWrap.innerHTML = '';
      quickSearch.classList.remove('is-active');
      return;
    }
    const searchUrl = `/catalog/?q=${encodeURI(value.trim().toLowerCase())}&ajax=Y`;
    wrapper.classList.add('is-loading');
    const response = await fetch(searchUrl, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    });
    if (!response.ok) {
      wrapper.classList.add('is-notfound');
      wrapper.classList.remove('is-loading');
      quickSearch.classList.add('is-active');
      return;
    }
    let result = [];
    try {
      result = await response.json();
    } catch (error) {
      result = [];
    }
    wrapper.classList.remove('is-loading');

    linksWrap.innerHTML = '';
    if (!result.length) {
      quickSearch.classList.remove('is-active');
      return;
    }

    const resultLinks = result.map((elem) => `<a class="searchres flexi" href="${elem.link}"><img src="${elem.image}" alt=""><span>${elem.name}</span></a>`);
    linksWrap.innerHTML = resultLinks.join('');
    quickSearch.classList.add('is-active');
  };

  document.addEventListener('input', debounce(async (e) => {
    const inputField = e.target.closest('.js-quicksearch input');
    if (!inputField) return;
    const { value } = e.target;
    const quickSearch = inputField.closest('.js-quicksearch').querySelector('.hdr__quick');
    const linksWrap = inputField.closest('.js-quicksearch').querySelector('.js-quicklinks');
    await searchAction(value, quickSearch, linksWrap);
  }, 200));

  document.addEventListener('focusin', async (e) => {
    const inputField = e.target.closest('.js-quicksearch input');
    if (!inputField) return;
    const { value } = e.target;
    const quickSearch = inputField.closest('.js-quicksearch').querySelector('.hdr__quick');
    const linksWrap = inputField.closest('.js-quicksearch').querySelector('.js-quicklinks');
    await searchAction(value, quickSearch, linksWrap);
  });

  document.addEventListener('click', (e) => {
    const wrapperBox = e.target.closest('.js-quicksearch');
    if (wrapperBox) return;
    document.querySelectorAll('.hdr__quick.is-active').forEach((elem) => elem.classList.remove('is-active'));
  });
};
export default initQuickSearch;
